import { Component, Input, OnInit } from '@angular/core';
import { PickingItemLogModel } from '@ov-suite/models-admin';
import { MatCustomDataSource } from '@ov-suite/ui';
import { ColumnData } from '@ov-suite/helpers-shared';
import { LoadManagementDataService } from '../../load-management.data.service';

@Component({
  selector: 'ov-suite-picking-item-log-modal',
  template: `
    <ov-suite-clean-table
      [dataSource]="pickingItemLogDataSource"
      [columnData]="columnData"
      [disablePaging]="true"
      [disableSorting]="true"
    >
    </ov-suite-clean-table>
  `,
})
export class PickingItemLogModalComponent implements OnInit {
  @Input() loadManagementDataService: LoadManagementDataService;

  pickingItemLogDataSource = new MatCustomDataSource<PickingItemLogModel>([]);

  columnData: ColumnData<PickingItemLogModel>[] = [
    {
      type: 'date',
      title: 'Date Completed',
      key: 'completedDate',
    },
    {
      type: 'deep-string',
      title: 'Handled By',
      key: 'handledByUser.username',
    },
    {
      type: 'deep-string',
      title: 'Container',
      key: 'containerPicked.name',
    },
  ];

  ngOnInit() {
    this.loadManagementDataService.pickingItemLog.subscribe(res => {
      this.pickingItemLogDataSource.data = res;
    });
  }
}
